import { render, staticRenderFns } from "./merchantShop.vue?vue&type=template&id=01aef0e4&scoped=true"
import script from "./merchantShop.vue?vue&type=script&lang=js"
export * from "./merchantShop.vue?vue&type=script&lang=js"
import style0 from "./merchantShop.vue?vue&type=style&index=0&id=01aef0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aef0e4",
  null
  
)

export default component.exports